<button [ngClass]="getClassObject()">
  @if (text) {
    <span>{{ text }}</span>
  }
  @if (icon) {
    <span>{{ icon }}</span>
  }
</button>
